export const parseStringToDom = (content: string) => {
  const parser = new DOMParser();
  return parser.parseFromString(content, "text/html").body;
};
